import styled, { css } from 'styled-components';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c   --muted: #79869e
   --border:  rgba(216, 224, 235, 0.9)
=========================================================== */

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;

  ${({ location }) =>
    location &&
    css`
      padding: 8px;
      background: #fff;
      border: 1px solid rgba(216, 224, 235, 0.9);
      border-radius: 12px;
      box-shadow: 0 6px 18px rgba(23, 38, 59, 0.06);
    `}
`;

export const Navigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    border: 1px solid transparent;
    border-radius: 10px;
    background: #eef2f8;
    color: #79869e;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease,
      transform 0.2s ease, border-color 0.2s ease;

    &:hover {
      color: #fff;
      background: linear-gradient(
        135deg,
        #ff6d3c 0%,
        #ff875f 52%,
        #ff9b78 100%
      );
      box-shadow: 0 8px 18px rgba(255, 109, 60, 0.32);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 4px 10px rgba(255, 109, 60, 0.28);
    }

    &:focus-visible {
      border-color: rgba(255, 109, 60, 0.55);
      box-shadow: 0 0 0 3px rgba(255, 109, 60, 0.18);
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px;

  ${({ location }) =>
    location &&
    css`
      flex: 1;
    `}

  & > form {
    display: flex;
    align-items: center;
  }

  span {
    margin-left: 8px;
    color: #79869e;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
  }
`;
